










import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace, Getter } from 'vuex-class';
import reportActions from '@/components/reports/report-actions.vue';
import layout from '@/layouts/app-layout.vue';
import breadcrumb from '@/components/breadcrumb.vue';
import { ActionConstants } from '@/stores/reports/action-constants';
import { ReportDetails } from '@/models/reports/report-details';

const Module = namespace('report');

@Component({
    components: {
        layout,
        breadcrumb,
        reportActions,
    },
})

export default class Reports extends Vue {
    public isLoading: boolean = true;
    @Module.Getter('allReportsTotalPages') public totalPages: number;
    @Module.Getter('allReportsPageSize') public currentPageSize: number;
    @Module.Getter('allReportsTotal') public totalReports: number;
    @Module.Getter('allReports') public reports: Array<ReportDetails>;
    @Module.Getter('allReportsPage') public currentPage: number;
    public createButtonVisible: boolean = true;

    public async handleReportDelete(): Promise<void> {
        this.isLoading = true;
        await this.$store.dispatch(ActionConstants.updateAllReportsPage, 1);
        await this.$store.dispatch(ActionConstants.fetch, { page: this.currentPage, pageSize: this.currentPageSize });

        this.isLoading = false;
    }

    public async handleCreateButtonVisibility(visible: boolean): Promise<void> {
        this.createButtonVisible = visible;
    }

    public async handlePageChanged(value: number): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateAllReportsPage, value);
        await this.$store.dispatch(ActionConstants.fetch, { page: this.currentPage, pageSize: this.currentPageSize });

        this.isLoading = false;
    }

    private async getReports(): Promise<void> {
        this.isLoading = true;
        await this.$store.dispatch(ActionConstants.updateAllReportsPage, 1);
        await this.$store.dispatch(ActionConstants.fetch, { page: this.currentPage, pageSize: this.currentPageSize });
        this.isLoading = false;
    }

    public hideCreateButton(): void {
        this.createButtonVisible = false;
    }

    public showCreateButton(): void {
        this.createButtonVisible = true;
    }
}
